import { render } from "./RequestDetailWindow.vue?vue&type=template&id=4b706676&scoped=true"
import script from "./RequestDetailWindow.vue?vue&type=script&lang=js"
export * from "./RequestDetailWindow.vue?vue&type=script&lang=js"

import "./RequestDetailWindow.vue?vue&type=style&index=0&id=4b706676&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b706676"]])

export default __exports__